import { Component } from '@angular/core';

@Component({
  selector: 'app-feed-advice-router',
  templateUrl: './feed-advice-router.component.html',
  standalone: false,
})
export class FeedAdviceRouterComponent {
  constructor() {}
}
